import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';

export const getCentroCosto = async () => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/centros?empresa=${userInfo.empresa}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const crearCentroCosto = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        
        const {data}  = await Axios.post(
            '/centros', clienteData
        );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const updateCentroCosto = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        const {data}  = await Axios.patch(
          `/centros/${clienteData._id}`, clienteData
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const deleteCentroCosto = (Id) => Axios.delete(`/centros/${Id}`);
